import {
  checkboxGroupSchema,
  checkboxGroupUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';

import {
  SERVICE_BRANCH_LABELS,
  CHECKBOXGROUP_HINT_TEXT,
} from '../../constants';

export default {
  uiSchema: {
    ...titleUI('Military service history'),
    serviceInformation: {
      serviceBranches: checkboxGroupUI({
        title: 'Which branches of the military have you served in?',
        hint: CHECKBOXGROUP_HINT_TEXT,
        labels: SERVICE_BRANCH_LABELS,
        required: true,
      }),
    },
  },
  schema: {
    type: 'object',
    required: ['serviceInformation'],
    properties: {
      serviceInformation: {
        type: 'object',
        required: ['serviceBranches'],
        properties: {
          serviceBranches: checkboxGroupSchema(
            Object.keys(SERVICE_BRANCH_LABELS),
          ),
        },
      },
    },
  },
};
